<template>
  <div id="addAddress">
    <mt-header fixed :title="$t('创建新地址')">
      <mt-button
        icon="back"
        slot="left"
        @click.native="$router.back()"
      ></mt-button>
      <!-- <mt-button slot="right" @click="Flicking()">
		  		<img src="../../assets/img/coinDetail/ico_saoyisao_fasong.png" alt="" class="sao">
		  	</mt-button> -->
    </mt-header>
    <div class="content">
      <!-- <div class="address">
        <input
          type="text"
          :placeholder="$t('名称')"
          class="wx_one_ellipsis wx_fontSize3"
          v-model="coinName"
          value="coinName"
        />
      </div> -->
      <div class="address">
        <span style="color: #666">{{ name }}</span>
        <!-- 点击·选择币种 -->
        <span class="contact" @click="coinList()">
          <img v-bind:src="img_url" alt="" class="mark" />
          <img
            src="../../assets/img/coinDetail/ico_gengduo.png"
            alt=""
            class="mark back"
          />
        </span>
      </div>
      <div class="address">
        <input
          type="text"
          :placeholder="$t('地址')"
          class="wx_one_ellipsis wx_fontSize3"
          v-model.trim="coinAddres"
        />
        <!-- <span class="warn">请输入正确的地址格式</span> -->
      </div>

      <div
        v-if="networks.length > 0"
        class="address s2"
        @click="showNetworks = true"
      >
        <span style="color: #666">{{ activeNetwork.name }}</span>
        <img
          src="../../assets/img/coinDetail/ico_gengduo.png"
          alt=""
          class="back"
        />
      </div>
      <div class="address">
        <input
          type="text"
          :placeholder="$t('备注(选填)')"
          class="wx_one_ellipsis wx_fontSize3"
          v-model.trim="remark"
          :maxlength="30"
        />
      </div>

      <div v-if="activeNetwork.withdraw_tips" class="withdraw-tip">
        {{ activeNetwork.withdraw_tips }}
      </div>
      <div class="footer wx_fontSize3" @click="getData()">
        {{ $t("立即创建") }}
      </div>
    </div>

    <!-- 选择网络弹框 -->
    <mt-popup v-model="showNetworks" position="bottom">
      <div class="pop-wrap">
        <div class="close" @click="showNetworks = false">{{ $t("关闭") }}</div>
        <div
          :class="['item', !item.withdraw_enable ? 'disabled' : '']"
          v-for="item in networks"
          :key="item.network"
          @click="onSelectNetwork(item)"
        >
          <div :style="{ color: !item.withdraw_enable ? '#959698' : '' }">
            {{ item.name }}
          </div>
          <img
            v-if="activeNetwork == item"
            class="icon"
            src="@/assets/img/success.png"
            alt=""
          />
        </div>
      </div>
    </mt-popup>
  </div>
</template>
<script>
import { httpAddAddress, httpAccountInfo } from "@/api/index";
import { Toast } from "mint-ui";
import { saoYiSaoMessage } from "@/utils/index";
import { validateEmpty } from "@/utils/validate";
export default {
  data() {
    return {
      title: "",
      name: "BTC",
      coinName: "",
      coinAddres: "",
      remark: "",
      id: "",
      value: {},
      img_url: require("../../assets/img/ico_btc.png"),
      type: 1,
      showNetworks: false,
      networks: [],
      activeNetwork: {},
    };
  },
  created() {
    window.getvalueFromApp = this.getvalueFromApp;
  },
  activated() {
    // 当选择币种后跳转传递信息
    // this.remark = "";
    // this.coinAddres = "";
    if (this.$route.query.result) {
      this.id = this.$route.query.result.id;
      this.name = this.$route.query.result.name;
      this.img_url = this.$route.query.result.img_url;
    } else {
      // 给默认初始值
      this.coinName = "";
      // this.coinAddres = "";
      this.name = "BTC";
    }

    // 获取云端币种详情
    httpAccountInfo({
      coin_symbol: this.name,
      currency: this.$store.getters.currency,
    })
      .then((res) => {
        this.coin_id = res.data.coin_id;
        this.networks = res.data.withdraw_network_list;
        this.activeNetwork = this.networks[0];
      })
      .catch(() => {});
    this.type = this.$route.query.type;
  },
  deactivated() {
    this.remark = "";
    this.coinAddres = "";
  },

  methods: {
    // check() {
    //   console.log(1);
    // },
    getData: function () {
      if (validateEmpty(this.coinAddres) || validateEmpty(this.name)) {
        Toast(this.$t("empty"));
        return;
      } else {
        httpAddAddress({
          // name: this.coinName,
          host: this.coinAddres,
          coin_id: this.coin_id,
          type: this.type,
          coin: this.activeNetwork.coin,
          network: this.activeNetwork.network,
          remark: this.remark,
        })
          .then((res) => {
            Toast(res.msg);
            // this.$router.push("/addressBook?title=" + `云端钱包地址簿`);
            this.$router.back();
          })
          .catch(() => {});
      }
    },
    coinList() {
      // 点击选择币种
      this.$router.push({ path: "/coinList", query: { type: this.type } });
    },
    Flicking() {
      saoYiSaoMessage();
    },
    getvalueFromApp(value) {
      Toast(value);
      this.coinAddres = value;
    },
    onSelectNetwork(item) {
      // 该属性为0不可选择网络
      if (!item.withdraw_enable) {
        return false;
      }
      this.activeNetwork = item;
      this.showNetworks = false;
    },
  },
};
</script>

<style scoped>
.mint-header {
  background: transparent;
  color: #212529;
  border-bottom: 1px solid #e3e8ed;
}
.mint-button--default {
  color: #656b79 !important;
}
.sao {
  width: 20px;
  height: 20px;
}
.content {
  padding: 0 15px;
  padding-top: 40px;
}
.address {
  height: 75px;
  line-height: 75px;
  border-bottom: 1px solid #e3e8ed;
  width: 100%;
  color: #a9afc8;
  position: relative;
}
.address.s2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.address input {
  width: 80%;
  height: 75px;
  line-height: 75px;
}
.contact {
  height: 26px;
  position: absolute;
  right: 0px;
  bottom: 20px;
  line-height: 26px;
  color: #212529;
}
.mark {
  width: 30px;
  height: 30px;
  position: relative;
  top: -8px;
}
.back {
  width: 7px;
  height: 12px;
  top: 0;
  margin-left: 14px;
  top: -16px;
}
.footer {
  width: 100%;
  height: 50px;
  background: #1296db;
  line-height: 50px;
  text-align: center;
  color: #ffffff;
  margin-top: 40px;
  border-radius: 4px;
}
.pop-wrap {
  width: 100vw;
  padding: 20px;
  box-sizing: border-box;
}
.pop-wrap .close {
  float: right;
  font-size: 14px;
  margin-bottom: 15px;
}
.pop-wrap .item {
  clear: both;
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #1296db;
  padding: 8px 10px;
  border-radius: 20px;
  margin: 10px 0;
}
.pop-wrap .item.disabled {
  opacity: 0.8;
  pointer-events: none;
  border-color: #eee;
}
.pop-wrap .item .icon {
  width: 20px;
}
.withdraw-tip {
  margin-top: 10px;
  font-size: 12px;
  opacity: 0.8;
}
.warn {
  font-size: smaller;
  position: absolute;
  top: 25px;
  color: red;
}
</style>
